var map = {
	"./businesses-icon-1.svg": 466,
	"./businesses-icon-2.svg": 467,
	"./businesses-icon-3.svg": 468,
	"./businesses-icon-4.svg": 469,
	"./companies-icon-1.svg": 470,
	"./companies-icon-2.svg": 471,
	"./companies-icon-3.svg": 472,
	"./companies-icon-4.svg": 473,
	"./students-icon-1.svg": 474,
	"./students-icon-2.svg": 475,
	"./students-icon-3.svg": 476,
	"./students-icon-4.svg": 477,
	"./universities-icon-1.svg": 478,
	"./universities-icon-2.svg": 479,
	"./universities-icon-3.svg": 480,
	"./universities-icon-4.svg": 481
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 465;